export default __webpack_public_path__ + "static/media/twinbed2.97c9f1af.jpg";